<template>
	<div>
		<base-header type="gradient-dbm" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>

		<div class="container-fluid mt--7">
			<div class="row">
				<div class="col" v-bind:style="{cursor:pointer2}">
					<leads-table title="Posibles clientes DB Menos"
							:data="tableData"
							:period="period"
							:pagination="pagination"
							v-on:pageSelected="getLeadList"
							v-on:calcuLeadSelected="calcuLeadSelected"
							v-on:leadSelected="leadSelected"
							v-on:toClient="toClient"
							v-on:setPeriodFilter="setPeriodFilter"
							v-on:setFollowFilter="setFollowFilter"
							v-on:setSellerFilter="setSellerFilter"
							v-on:setStatusFilter="setStatusFilter"/>
				</div>
			</div>
		</div>

		<modal :show.sync="tracingModal" v-on:close="closeModal()" v-bind:large="true">
			<template slot="header">
				<h2 class="mb-0" id="TracingLead" style="margin-top: 20px; margin-left: 10px">{{selectedLead.name}}</h2>
			</template>
			<div v-if="newTrace">
				<div class="col-lg-12">
					<base-dropdown>
						<base-button slot="title" type="success" class="dropdown-toggle" size="sm">
							{{trace.status ? trace.status : "Seleccionar"}}
						</base-button>
						<a class="dropdown-item" href="#" v-for="(status, index) in tracingStatus" :key="index" v-on:click="trace.status = status.status">{{status.status}}</a>
					</base-dropdown>
					<base-input alternative=""
								placeholder="Comentarios"
								input-classes="form-control-alternative"
								style="margin-top: 20px"
								v-model="trace.comments"/>
				</div>
				<div class="col text-right">
					<base-button slot="title" type="primary" v-on:click="uploadTrace()">Crear</base-button>
				</div>
			</div>
			<div v-else>
				<leads-tracing-table title="Seguimiento"
									:data="TracingTableData"
									v-on:newLeadTrace="newLeadTrace"/>
			</div>
		</modal>

		<modal :show.sync="calcModal" v-on:close="calcModal=false" v-bind:large="true">
            <template slot="header">
                <h2 class="mb-0" id="acountModal" style="margin-top: 20px; margin-left: 10px">Calculadora de descuentos</h2>
            </template>

                <div class="row justify-content-center" v-if="selectedLead.calculation">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Total adeudado</h6>
                                        <span class="h2 font-weight-bold mb-0">${{Number.parseFloat(selectedLead.calculation.totalDebt).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-red text-white rounded-circle shadow">
                                            <i class="fas fa-money-bill"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5" v-if="selectedLead.calculation">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Ahorros</h6>
                                        <span class="h2 font-weight-bold mb-0">${{Number.parseFloat(selectedLead.calculation.savings).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-success text-white rounded-circle shadow">
                                            <i class="fas fa-dollar-sign"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="selectedLead.calculation">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Duración del programa</h6>
                                        <span class="h2 font-weight-bold mb-0">{{selectedLead.calculation.period}} meses</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                                            <i class="fas fa-clock"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5" v-if="selectedLead.calculation">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Depósito mensual</h6>
                                        <span class="h2 font-weight-bold mb-0">${{Number.parseFloat(selectedLead.calculation.montlyFee).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-blue text-white rounded-circle shadow">
                                            <i class="fas fa-coins"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="selectedLead.calculation">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Descuento estimado</h6>
                                        <span class="h2 font-weight-bold mb-0">{{Number.parseFloat(selectedLead.calculation.discount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}%</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                                            <i class="fa fa-percent"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-5" v-if="selectedLead.calculation">
                        <div class="card card-stats mb-4 mb-xl-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-0">Deudas</h6>
                                        <span class="h2 font-weight-bold mb-0">{{selectedLead.calculation.debts.length}}</span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="icon icon-shape bg-indigo text-white rounded-circle shadow">
                                            <i class="fas fa-check"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="selectedLead.calculation">
                    <div class="col-xl-10 col-lg-10 col-md-10">
                        <div class="card shadow">
                            <div class="card-header border-0">
                                <h3 class="mb-0">Deudas a liquidar</h3>
                            </div>
                            <div class="table-responsive">
                                <table class="table align-items-center table-flush">
                                    <thead class="thead-light">
                                    <tr>
                                        <th class="text-center" scope="col">Deuda</th>
                                        <th class="text-center" scope="col">Acreedor</th>
                                        <th class="text-center" scope="col">Deuda sin dbm</th>
                                        <th class="text-center" scope="col">Valor a pagar con dbm</th>
                                        <th class="text-center" scope="col">Mes a pagar</th>
                                        <th class="text-center" scope="col">Avance</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(debt, index) in selectedLead.calculation.debts" :key="index">
                                        <td class="text-center">
                                            {{index + 1}}
                                        </td>
                                        <td class="text-center">
                                            {{debt.bank}}
                                        </td>
                                        <td class="text-center">
                                            ${{Number.parseFloat(debt.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                        </td>
                                        <td class="text-center">
                                            ${{Number.parseFloat(debt.willPay).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                        </td>
                                        <td class="text-center">
                                            {{debt.willPayOnMonth}}
                                        </td>
                                        <td class="text-center">{{Number.parseFloat(debt.o_progress).toFixed(2)}}%
                                                <!--<div>
                                                    <div class="progress">
                                                        <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="47.7" aria-valuemin="0" aria-valuemax="100" v-bind="{style: debt.willPay / discount.totalDebt * 100}"></div>
                                                    </div>
                                                </div>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            
            <template slot="footer">
                <base-button type="primary" v-on:click="calcModal=false">Cerrar</base-button>
            </template>
        </modal>

	</div>
</template>
<script>
	import LeadsTable from './Tables/LeadsTable'
	import LeadsTracingTable from './Tables/LeadsTracingTable'
	export default {
		name: 'tables',
		components: {
			LeadsTable,
			LeadsTracingTable
		},
		mounted() {
			this.getLeadList(1)
			this.$root.$on('searchQuery', query => {
				if (query.length > 0)
					this.searchQuery = query
				else
					this.searchQuery = null
				this.getLeadList(1)
			})
		},
		computed: {
			user() { return this.$getLS(this.$v.STORE_KEYS.USER) },
			generalInfo() { return this.$store.state.generalInfo },
			tracingStatus() { return this.$store.state.tracingStatus }
		},
		data() {
			return {
				searchQuery: null,
				pagination: {
					total: 0,
					perPage: 10,
					currentPage: 1
				},
				tableData: [],
				tracingModal: false,
				newTrace: false,
				trace: {
					status: null,
					comments: ""
				},
				TracingTableData: [],
				selectedLead: {},
				periodFilter: null,
				period: {
					start: null,
					end: null
				},
				statusFilter: null,
				followFilter: null,
				sellerFilter: null,
				pointer: 'pointer',
				pointer2: 'default',
				calcModal: false,
			};
		},
		async created() { },
		methods: {
			getLeadList(page) {
				let limit = this.pagination.perPage
				let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_LEADS + "?offset=" + limit*(page - 1) + "&limit=" + limit
				if (this.user.role === this.$v.ROLES.SELLER)
					url += "&seller=" + this.user.id
				if (this.statusFilter !== null) {
					if (this.statusFilter === 'Sin seguimiento') {
						url += "&trace_id=null"
					} else {
						url += "&status=" + this.statusFilter
					}
				} else if (this.followFilter !== null) url += "&follow=" + this.followFilter
				if (this.periodFilter === 1) url += "&periodStart="+this.period.start
				if (this.periodFilter === 2) url += "&periodStart="+this.period.start+"&periodEnd="+this.period.end
				if (this.searchQuery) url += "&find=" + this.searchQuery
				if (this.sellerFilter) url += "&seller=" + this.sellerFilter
				this.$showLoader(true)
				this.$axios.get(url).then(response => {
					this.$showLoader(false)
					let data = response.data
					if (data[this.$v.API_SUCCESS]) {
						this.tableData = data[this.$v.API_ROWS]
						let p = data[this.$v.API_ROW]
						this.pagination.total = p['totalItems']
						this.pagination.currentPage = page
						this.pagination.perPage = limit
					} else { this.$validateSession(data) }
				})
			},
			calcuLeadSelected(lead) {
				this.selectedLead = lead
				if(this.selectedLead.calculation)
					this.calcModal = true
			},
			leadSelected(lead) {
				this.TracingTableData = []
				this.selectedLead = lead
				this.tracingModal = true
				this.downloadLeadTracing()
			},
			toClient(lead) {
				let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_USER_FROM_LEAD + "?lead=" + lead.id
				this.$showLoader(true)
				this.$axios.get(url).then(response => {
					this.$showLoader(false)
					let data = response.data
					if (data[this.$v.API_SUCCESS]) {
						let clientID = data[this.$v.API_ROW]
						if (clientID) {
							window.open("http://admin.dbmenos.com/#/client?id="+clientID, '_blank')
						}
					} else {
						this.$notify({
                                text: "El lead no tiene perfil de cliente asociado",
                                type: 'info'
                            })
					}
				})
			},
			downloadLeadTracing() {
				let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_SELL_TRACING //+ "?user=" + this.selectedLead.id
				let request={
					lead: this.selectedLead.id
				}
				this.$showLoader(true)
				this.$axios.post(url,request).then(response => {
					this.$showLoader(false)
					if (response.data[this.$v.API_SUCCESS]) {
						this.TracingTableData = response.data[this.$v.API_ROWS]
					}
				})
			},
			newLeadTrace() {
				this.newTrace = true
			},
			setPeriodFilter(value) {
				if(value === 1){
					let date = new Date()
					let month = date.getMonth()+1
					if(month<10) month= "0"+month
					this.period.start = date.getFullYear()+"-"+month+"-"+"01"
				}
				this.periodFilter = value
				this.getLeadList(1)				
			},
			setFollowFilter(value) {
				this.followFilter = value
				this.statusFilter = null
				this.getLeadList(1)
			},
			setSellerFilter(value) {
				this.sellerFilter = value
				this.getLeadList(1)
			},
			setStatusFilter(value) {
				this.statusFilter = value
				this.followFilter = null
				this.getLeadList(1)
			},
			uploadTrace() {
				let id = 0
				for (let t=0 ; t<this.tracingStatus.length ; t++) {
					if (this.tracingStatus[t].status === this.trace.status) {
						id = this.tracingStatus[t].id
						break
					}
				}
				if (id === 0 || this.trace.comments === "") {
					this.$notify({
						text: "Datos incompletos",
						type: 'warn'
					})
					return
				}
				let json = {
					status: id,
					lead: this.selectedLead.id,
					comments: this.trace.comments
				}
				let url = this.$v.SERVER + this.$v.SELLER_OPS.SET_SELL_TRACING
				this.$showLoader(true)
				this.$axios.post(url, json).then(response => {
					this.$showLoader(false)
					if (response.data[this.$v.API_SUCCESS]) {
						this.$notify({
							text: "Carga exitosa",
							type: 'success'
						})
						this.closeModal()
						this.trace.id = 0
						this.trace.status = null
						this.trace.comments = ""
					} else {
						this.$notify({
							text: "Falló la carga",
							type: 'error'
						})
					}
				})
			},
			closeModal() {
				this.tracingModal = false
				this.newTrace = false
			}
		}
	};
</script>
<style></style>